// extracted by mini-css-extract-plugin
module.exports = {"root":"FullscreenOverlay__root___3FxtJ","rootIE":"FullscreenOverlay__rootIE___3032M","paper":"FullscreenOverlay__paper___2pFEn"};